import mordern from '../images/modern-dentistry.png';
import appointment from '../images/appointment.png';
import insurance from '../images/dental-insurance.png';
import emergency from '../images/emergency.png'

const data = [
    {
        id:"adv-1",
        title:"Modern Dentistry",
        para:"The field of dentistry is constantly evolving. New techniques and procedures expand dentists’ capabilities and deliver more comfortable, long-lasting, and effective solutions to dental patients.",
        icon: mordern,
        link: null,
        anchor: null,
    },
    {
        id:"adv-2",
        title:"After Hour Appointments",
        para:"We are open after hours by appointment and we are also open on Saturdays.",
        icon: appointment,
        link: null,
        anchor: null,
    },
    {
        id:"adv-3",
        title:"Dental Insurance",
        para:"Carrum Downs Dental Group is a HCF and NIB Preferred Provider. We accept most Dental Insurance and also public dental vouchers (CDBS and VDS).",
        icon: insurance,
        link: null,
        anchor: null,
    },
    {
        id:"adv-4",
        title:"Dental Emergency",
        para:"Starting your day with a missing tooth or even worse – extreme pain and don’t know where to go? Call us now.",
        icon: emergency,
        link: null,
        anchor: null,
    }
];

export default data;